/**
 * UsuarioTemplate — CRUD de Usuario (operadores/administradores do próprio tenant).
 *
 * Cada tenant gerencia os próprios usuários (ao contrário de Permissao, que é catálogo global
 * só do principal) — sem `requiresAcessoGeral` aqui, ver RotasService.
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelSenha } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { Usuario } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import { buildRelacionados } from '../../../service/RotasService';

const model = {
  nome: { exibir: 'main.usuario.nome', visivel: true, validacao: { obrigatorio: true } },
  email: { exibir: 'main.usuario.email', visivel: true, keyfilter: 'email', validacao: { obrigatorio: true, email: true } },
  pass: { exibir: 'main.usuario.pass', validacao: { obrigatorio: true, tamanhominimo: 6 } },
  passConf: { exibir: 'main.usuario.passConf', validacao: { obrigatorio: true, identico: { campo: 'pass', descricao: 'Senha' } } },
  ativo: { exibir: 'main.usuario.ativo', visivel: true, tipo: 'boolean' },
  ultimoacesso: { exibir: 'main.usuario.ultimoacesso', visivel: true, tipo: 'date', time: true, disabled: true },
};

class UsuarioFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.usuario.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.nome} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.email} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelSenha model={model.pass} contexto={contexto} mostrarMetricas={true} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelSenha model={model.passConf} contexto={contexto} mostrarMetricas={false} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelBoolean model={model.ativo} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class UsuarioTemplate extends Component {
  render() {
    return (
      <EntityGrid
        entidade={Usuario}
        model={model}
        identidade="main.usuario"
        permissoes={this.props.permissoes}
        icone="pi-user"
        storageKey="dt-usuarios"
        getRelacionados={(selected) => buildRelacionados('usuario', this.props.permissoes, this.props.navigate, () => selected?.[0])}
        configuracao={this.props.configuracao}
        navigate={this.props.navigate}
        location={this.props.location}
        searchparams={this.props.searchparams}
        formulario={(m, ctx) => <UsuarioFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default UsuarioTemplate;
